export {};
//# sourceMappingURL=crash-buffer.js.map